(ns manatee.admin.rejection-option.app-db
  "app-db support for the admin/rejections tab."
  (:require [manatee.admin.app-db :as admin-app-db]))

(def ^:private root-path (conj admin-app-db/root-path :rejection-option))
(def ^:private rejection-options-path (conj root-path :rejection-options))
(def ^:private selected-rejection-option-id-path (conj root-path :selected-rejection-option-id))
(def ^:private list-view?-path (conj root-path :list-view?))

(defn get-selected-rejection-option-id
  [db]
  (get-in db selected-rejection-option-id-path))

(defn set-selected-rejection-option-id
  [db id]
  (assoc-in db selected-rejection-option-id-path id))

(defn list-view?
  [db]
  (get-in db list-view?-path true))

(defn set-list-view
  [db flag]
  (assoc-in db list-view?-path flag))

(defn set-rejection-options
  [db rejection-options]
  (assoc-in db rejection-options-path rejection-options))

(defn get-rejection-options
  [db]
  (get-in db rejection-options-path))
